import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() {
      this.canvasForm = this.svg
      .append('g')
      .attr('id', `CANVAS_FROM`)
      .attr('transform', `translate(5, 0)`)
      .attr('font-family', 'roboto')
      .attr('cursor', 'default')

      this.canvasForm
      .append('image')
      .attr('xlink:href', this.HOST + '/icon/Logo/TrionFPU_r1.svg')
      .attr('x', 10).attr('y', 15).attr('width', 230)

      this.canvasForm
      .append('text')
      .attr('transform', `translate(10, 82)`)
      .attr('font-size', 18)
      .attr('fill', '#000')
      .text(this.title.TITLE)

      this.canvasForm
      .append('text')
      .attr('transform', `translate(10, 95)`)
      .attr('font-size', 12)
      .attr('fill', '#44A9DF')
      .text(this.title.SOURCE)
 

      this.draw_Header()
      this.draw_BlockList()

     

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },


  }
}